import React, { useState } from 'react'
import { Button, makeStyles } from '@material-ui/core'
import Modal from 'src/components/common/Modal'
import ViewDownloadReportFiles from 'src/components/RiskCategories/components/ViewDownloadReportFiles'
import { COLORS } from 'src/utils/Themes/colors'

const DownloadReports = ({ title, text, Icon, downloadReportData }) => {
  const classes = useStyles()
  const [viewUploadedFiles, setViewUploadedFiles] = useState(false)
  const closeViewUploadedFiles = () => {
    setViewUploadedFiles(false)
  }

  return (
    <div className={classes.root}>
      {viewUploadedFiles ? (
        <>
          <Modal
            bgcolor={'#FFFFFF'}
            ordered={viewUploadedFiles}
            width={'60%'}
            left={'20%'}
            top={'5%'}
            modelClosed={closeViewUploadedFiles}
            class={classes.modalRoot}
          >
            <div className={classes.modalContent}>
              <ViewDownloadReportFiles
                category={false}
                closeModal={closeViewUploadedFiles}
                downloadReportData={downloadReportData}
              />
            </div>
          </Modal>
        </>
      ) : null}

      <div className={classes.title} id='title'>
        {title}
        <Button
          id='download-button'
          variant='contained'
          classes={{ root: classes.btn }}
          // disabled={disabled}
          onClick={() => {
            setViewUploadedFiles(true)
          }}
        >
          {text}
        </Button>
      </div>
      {Icon ? (
        <div className={classes.icon}>
          <img src={Icon} alt='icon' />
        </div>
      ) : null}
    </div>
  )
}

export default DownloadReports

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    alignItems: 'center',
    background: 'linear-gradient(74.06deg, #EBEBEB 0%, #FFFFFF 100%)',
  },
  title: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: COLORS.DARK_PINK,
    padding: '16px 0px 16px 16px',
    '& button': {
      marginTop: '15px',
    },
  },
  icon: {
    width: '75px',
    padding: '0px 20px',
    flexShrink: 0,
    '& svg': {
      maxWidth: '100%',
    },
    '& img': {
      maxWidth: '100%',
    },
  },
  btn: {
    backgroundColor: COLORS.DARK_PINK,
    color: COLORS.WHITE,
    borderRadius: '60px',
    padding: '3px 16px',
    fontSize: '12px',
    width: 'max-content',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#cf4a72',
    },
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
  },
  modalRoot: {
    height: '90%',
  },
})
